import Image from 'next/image';
import styled from 'styled-components';
import { device } from '../../styles/device';
import StyledLink from '../global/StyledLink';
import EmailSVG from '/public/svg/team/email.svg';
import LinkedInSVG from '/public/svg/team/linkedin.svg';
import XingSVG from '/public/svg/team/xing.svg';

export enum SocialLinkType {
    Xing, LinkedIn, Email, Website
}

const TeamCardContainer = styled.div`
    position: relative;
    height: 500px;
    width: 362px;
    border-radius: 16px;
    padding-left: 18px;
    padding-right: 18px;
    padding-bottom: 25px;
    padding-top: 25px;
    display: flex;
    align-items: flex-end;

    img {
        border-radius: 16px;
    }

    span::after {
        content: '';
        position: absolute;
        border-radius: 16px;
        top:0;
        left: 0;
        height: 100%;
        width: 100%;
        background-image: linear-gradient(180deg,rgba(0,0,0,0) 72%,rgba(0,0,0,0.65));
    }

    @media ${device.tablet} {
        height: 500px;
        width: 400px;
    }

    .text-wrapper {
        position: relative;
        p {
            font-size: 24px;
            line-height: 32px;
            font-weight: 700;
            color: #FFFFFF;
            margin-top: 0;
            margin-bottom: 8px;
        }

        .social-links {
            display: flex;
            flex-direction: row;
            column-gap: 16px;

            svg {
                height: 30px;
                width: 30px;
            }
        }
    }
`;

export const TeamCard = ({ name, links, imageSrc }) => {
    return (
        <TeamCardContainer>
            <Image
                src={imageSrc}
                alt={name + " Team Image"}
                layout="fill"
                objectFit='cover'
                quality={100}
            />
            <div className='text-wrapper'>
                <p>{name}</p>
                <div className='social-links'>
                    {links.map((link) => {
                        if (link?.type === SocialLinkType.Xing) {
                            return (
                                <StyledLink key={link.type} href={link.href} >
                                    <XingSVG />
                                </StyledLink>
                            )
                        }
                        if (link?.type === SocialLinkType.LinkedIn) {
                            return (
                                <StyledLink key={link.type} href={link.href} >
                                    <LinkedInSVG />
                                </StyledLink>
                            )
                        }
                        if (link?.type === SocialLinkType.Email) {
                            return (
                                <StyledLink key={link.type} href={link.href} >
                                    <EmailSVG />
                                </StyledLink>
                            )
                        }
                    })}
                </div>
            </div>
        </TeamCardContainer>
    )
}
